import { isMeasure } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { getYAxisColumns } from '../../../core/chart-model-utils';
import { isSinglePointKPIEnabledWithValue, isSinglePointKPIEnabledWithOnlyCurrentValue, isKpiChartTypeTimeseries, isSparklineEnabled, } from '../kpi-utils';
export function ellipsifyBlocks(containerWidth, childrenWidths) {
    let offset = 0;
    return childrenWidths.map(_childWidth => {
        const blockVal = {
            isHidden: containerWidth < offset,
            isEllipsis: containerWidth < _childWidth + offset,
            width: containerWidth < _childWidth + offset
                ? containerWidth - offset
                : 'auto',
        };
        offset += _childWidth;
        return blockVal;
    });
}
export function shouldShowSparkline(chartModel) {
    const yAxisColumn = _.first(getYAxisColumns(chartModel));
    const isYAxisColumnMeasure = !!yAxisColumn && isMeasure(yAxisColumn);
    const isSinglePointKPIEnabled = isSinglePointKPIEnabledWithValue(chartModel) ||
        isSinglePointKPIEnabledWithOnlyCurrentValue(chartModel);
    const isChartMeasureTimeSeries = (isKpiChartTypeTimeseries(chartModel) || isSinglePointKPIEnabled) &&
        isYAxisColumnMeasure;
    return (isChartMeasureTimeSeries &&
        isSparklineEnabled(chartModel) &&
        !isSinglePointKPIEnabled);
}
//# sourceMappingURL=utils.js.map